module.exports = __webpack_public_path__ + "static/media/p1.323ca4f2.png";